<template>
  <div class="StudyItemContainer">
    <nut-row class="bothCenter" v-if="data.type == 'IMG'">
      <photo-provider>
        <photo-consumer :src="data.dataUrl" style="text-align: left;width: 100%">
          <div class="wd100">
            <nut-col :span="24" class="leftCenter">
              <div class="cover" :style="{backgroundImage:`url(${data.previewImage}?x-oss-process=image/resize,p_30)`}">
                <div class="tag">
                  <img src="../../assets/image/check.png"/>
                  <span>{{ data.viewCnt }}</span>
                </div>
              </div>
            </nut-col>
            <nut-col :span="24" class="colFlex">
              <span class="title">{{ data.name }}</span>
<!--              <span class="postTime">{{ data.createdTime.substring(0, 10) }}</span>-->
            </nut-col>
          </div>
        </photo-consumer>
      </photo-provider>
    </nut-row>
    <nut-row v-else>
      <nut-col :span="24" class="leftCenter">
        <div class="cover" :style="{backgroundImage:`url(${data.dataUrl}?x-oss-process=video/snapshot,t_5000)`}">
          <div class="tag">
            <img src="../../assets/image/check.png"/>
            <span>{{ data.viewCnt }}</span>
          </div>
        </div>
      </nut-col>
      <nut-col :span="24" class="colFlex">
        <span class="title">{{ data.name }}</span>
<!--        <span class="postTime">{{ data.createdTime.substring(0, 10) }}</span>-->
      </nut-col>
    </nut-row>
  </div>
</template>

<script>
export default {
  name: "StudyItem",
  data() {
    return {
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.StudyItemContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 10px 10px 8px;
  border-radius: 8px;
  margin-bottom: 8px;
  width: 43%;

  .cover {
    position: relative;
    background-image: url("https://cdn.waityou.online/81a925eb-cb14-b569-140e-dcdd74816bd5.png");
    background-size: cover;
    height: 20vw;
    width: 100%;
    border-radius: 5px;

    .tag {
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.5);
      color: #ccc;
      display: flex;
      padding: 0 4px;
      border-radius: 8px 0px 8px 0px;
      align-items: center;

      span {
        padding: 2px;
        font-size: $minFontSize;
      }
      img{
        width: 12px;
        height: 12px;
        margin-right: 2px;
      }
    }
  }

  .title {
    // margin-left: 6px;
    padding-top: 6px;
    font-size: $smallerFontSize;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 3.0em; /* 设置为行高的两倍 */
    line-height: 1.5em; /* 这里的行高应与下面p标签中的行高一致 */
  }

  .postTime {
    margin-left: 6px;
    font-size: $miniFontSize;
  }
}
</style>